<template>
  <router-view :test="reloadMainSite"></router-view>
</template>

<script>
import { ProfileNavRouter } from '@/router'
import { mapGetters } from 'vuex'

export default {
  name: 'ProfileNavigation',
  router: ProfileNavRouter,
  created: function () {
    // this.mainSite()
  },
  props: {},
  data: () => ({}),
  computed: {
    ...mapGetters(['isProfileNavActive']),
    reloadMainSite: function () {
      if (this.isProfileNavActive && !this.$router.currentRoute.name) {
        this.mainSite()
      }
    }
  },
  methods: {
    mainSite () {
      this.$router.currentRoute.name !== 'Profile' &&
        this.$router.push({ name: 'Profile' })

      // this.$router.push({ name: 'Profile' })
    }
  },
  mounted: function () {
    this.$emit('navigatorLoaded')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/ProfileNavigation.vue